export interface User {
    C_UserStatusType_key: number;
    C_SalutationType_key: number;
    C_CurrentWorkgroup_key: number | null;
    C_Customer_key: number | null;
    UserName: string;
    JobTitle: string;
    FirstName: string;
    LastName: string;
    NameSuffix: string;
    IsActive: boolean | null;
    EmailVerificationCode: string;
    PendingEmailVerification: boolean | null;
    EmailVerificationCodeGenerationTime: Date | null;
    CreatedBy: string;
    ModifiedBy: string;
    DateCreated: Date | null;
    DateModified: Date | null;
}
